module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header",
    style: (_vm.bjStyle)
  }, [(_vm.locale == 'en') ? _c('img', {
    attrs: {
      "src": require("../../imgs/sectop.png"),
      "width": "100%"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.locale == 'ch') ? _c('img', {
    attrs: {
      "src": require("../../imgs/banner_cn.png"),
      "width": "100%"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('span', {
    staticClass: "idx_title",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(_vm._s(_vm.$t("sIndex.index")))]), _c('span', {
    staticClass: "fx"
  }, [_vm._v(">")]), _c('span', {
    staticClass: "s_title"
  }, [_vm._v(_vm._s(_vm.$t("order.orderInfo")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cancelBtnShow),
      expression: "cancelBtnShow"
    }],
    staticClass: "s_title",
    class: {
      ca_mg_ch: _vm.locale == 'ch', ca_mg_en: _vm.locale == 'en'
    },
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.cacelOrder
    }
  }, [_vm._v(_vm._s(_vm.$t("pay.delOrder")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.countDown != ''),
      expression: "countDown!=''"
    }],
    class: {
      'leftPad': _vm.locale == 'ch' && !_vm.cancelBtnShow, 'leftPadEn': _vm.locale == 'en' && !_vm.cancelBtnShow
    },
    staticStyle: {
      "color": "red",
      "font-size": "18px",
      "margin-left": "30px",
      "padding-top": "3px"
    }
  }, [_vm._v(_vm._s(_vm.$t("pay.paydown")) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "18px",
      "margin-left": "10px",
      "padding-top": "3px"
    }
  }, [_vm._v(_vm._s(_vm.countDown))])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("morder.infoTitle")))]), _vm._v(" "), _c('span', {
    class: {
      mg_en: _vm.locale == 'en', mg_ch: _vm.locale == 'ch'
    }
  }, [_c('button', {
    class: {
      wd_en: _vm.locale == 'en', wd_ch: _vm.locale == 'ch'
    },
    staticStyle: {
      "background-color": "#FFF",
      "border-radius": "20px",
      "border": "1px solid #F39800",
      "font-size": "16px",
      "color": "#F39800",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goInfo
    }
  }, [_vm._v(_vm._s(_vm.$t("pay.modInfo")))])])]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.userConfig), function(user, index) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "10px",
        "width": "400px",
        "float": "left"
      }
    }, [_c('label', {
      staticStyle: {
        "display": "inline-block",
        "width": "200px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(user.cfgName) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(user.cfgValue != null && user.cfgValue.length > 15 ? user.cfgValue.substr(0, 15) + "..." : user.cfgValue))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("morder.signTitle")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.register.regFl == '6' || _vm.register.regFl == '4'),
      expression: "register.regFl=='6'||register.regFl=='4'"
    }],
    class: {
      mg_en: _vm.locale == 'en', mg_ch: _vm.locale == 'ch'
    }
  }, [_c('button', {
    class: {
      wd_en: _vm.locale == 'en', wd_ch: _vm.locale == 'ch'
    },
    staticStyle: {
      "background-color": "#FFF",
      "border-radius": "20px",
      "border": "1px solid #F39800",
      "font-size": "16px",
      "color": "#F39800",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goReg
    }
  }, [_vm._v(_vm._s(_vm.$t("order.addReg")))])])]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "o_label"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("morder.signType")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.feeName))]), _vm._v(" "), (_vm.register.regFl == '2') ? _c('span', {
    class: {
      draw2_mg_ch: _vm.locale == 'ch', draw2_mg_en: _vm.locale == 'en'
    },
    staticStyle: {
      "font-size": "16px",
      "color": "#F39800",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.refundReg(_vm.register.regId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("pay.drawback")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pay",
    class: {
      pay_mg_en: _vm.locale == 'en', pay_mg_ch: _vm.locale == 'ch'
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.payType")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.register.regPayway == '1' ? _vm.$t("pay.payOnline") : _vm.$t("pay.payOffline")))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.payStatus")) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.register.regFl == '0' || _vm.register.regFl == '1' ? _vm.$t("pay.nopay") : _vm.register.regFl == '2' ? _vm.$t("pay.payed") : _vm.register.regFl == '4' ? _vm.$t("pay.drawback") : _vm.register.regFl == '5' ? _vm.$t("pay.drawbacked") : ""))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.regMoneyTitle")) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.register.regMoney) + _vm._s(_vm.locale == 'en' ? "CNY" : "元"))])])])]), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("morder.hotelTitle")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hotel_unpaid_fl == '0'),
      expression: "hotel_unpaid_fl=='0'"
    }],
    class: {
      mg2_en: _vm.locale == 'en', mg_ch: _vm.locale == 'ch'
    }
  }, [_c('button', {
    class: {
      wd_en: _vm.locale == 'en', wd_ch: _vm.locale == 'ch'
    },
    staticStyle: {
      "background-color": "#FFF",
      "border-radius": "20px",
      "border": "1px solid #F39800",
      "font-size": "16px",
      "color": "#F39800",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goHotel
    }
  }, [_vm._v(_vm._s(_vm.$t("hotel.isHotelTitle")))])])]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _vm._l((_vm.hotel_books), function(hotelBook) {
    return _c('div', [_c('div', {
      staticClass: "o_label"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t("morder.hotelName")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(hotelBook.hotel.hName))]), _vm._v(" "), (hotelBook.bookPayway == '2' && hotelBook.bookFl != '2') ? _c('span', {
      class: {
        mod_mg_ch: _vm.locale == 'ch', mod_mg_en: _vm.locale == 'en'
      },
      staticStyle: {
        "font-size": "16px",
        "color": "#F39800",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.modHotel(hotelBook)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("pay.modHotel")))]) : _vm._e(), _vm._v(" "), (hotelBook.bookPayway == '2' && hotelBook.bookFl != '2') ? _c('span', {
      staticStyle: {
        "font-size": "16px",
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.delHotel(hotelBook.bookId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("pay.delHotel")))]) : _vm._e(), _vm._v(" "), (hotelBook.bookFl == '2') ? _c('span', {
      class: {
        draw_mg_ch: _vm.locale == 'ch', draw2_mg_en: _vm.locale == 'en'
      },
      staticStyle: {
        "font-size": "16px",
        "color": "#F39800",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.refundHotel(hotelBook.bookId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("pay.drawback")))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "o_label"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t("morder.roomType")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(hotelBook.room.rmName))]), _vm._v(" "), _c('label', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t("hotel.inHotelTime")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._f("formatDt")(hotelBook.bookStartDt)))]), _vm._v(" "), _c('label', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t("hotel.outHotelTime")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._f("formatDt")(hotelBook.bookEndDt)))])]), _vm._v(" "), _c('div', {
      staticClass: "o_label"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t("hotel.days")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(hotelBook.bookDays) + _vm._s(_vm.$t("morder.night")))]), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (hotelBook.bookRoomieName != '' && hotelBook.bookRoomieName != null),
        expression: "hotelBook.bookRoomieName!=''&& hotelBook.bookRoomieName!=null"
      }],
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t("hotel.togeName")) + ":")]), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (hotelBook.bookRoomieName != '' && hotelBook.bookRoomieName != null),
        expression: "hotelBook.bookRoomieName!='' && hotelBook.bookRoomieName!=null"
      }]
    }, [_vm._v(_vm._s(hotelBook.bookRoomieName))]), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (hotelBook.bookRoomiePhone != '' && hotelBook.bookRoomiePhone != null),
        expression: "hotelBook.bookRoomiePhone!=''&& hotelBook.bookRoomiePhone!=null"
      }],
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t("hotel.togePhone")) + ":")]), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (hotelBook.bookRoomiePhone != '' && hotelBook.bookRoomiePhone != null),
        expression: "hotelBook.bookRoomiePhone!='' && hotelBook.bookRoomiePhone!=null"
      }]
    }, [_vm._v(_vm._s(hotelBook.bookRoomiePhone))])]), _vm._v(" "), _c('div', {
      staticClass: "pay",
      class: {
        pay_mg_en: _vm.locale == 'en', pay_mg_ch: _vm.locale == 'ch'
      }
    }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.payType")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(hotelBook.bookPayway == '1' ? _vm.$t("pay.payOnline") : _vm.$t("pay.payOffline")))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.payStatus")) + ":")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(hotelBook.bookFl == '0' || hotelBook.bookFl == '1' ? _vm.$t("pay.nopay") : hotelBook.bookFl == '2' ? _vm.$t("pay.payed") : hotelBook.bookFl == '4' ? _vm.$t("pay.drawback") : hotelBook.bookFl == '3' ? _vm.$t("pay.payFail") : ""))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("hotel.hotelMoney")) + ":")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(hotelBook.bookMoney) + _vm._s(_vm.locale == 'en' ? "CNY" : "元"))])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regConfig.cfgInvoiceFl == '1' && _vm.locale == 'ch'),
      expression: "regConfig.cfgInvoiceFl=='1'&&locale=='ch'"
    }],
    staticClass: "title",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("morder.invTitle")))]), _vm._v(" "), (_vm.register.regInvoiceType == '0' || _vm.register.regInvoiceType == null) ? _c('span', {
    class: {
      mg_en: _vm.locale == 'en', mg_ch: _vm.locale == 'ch'
    }
  }, [_c('button', {
    class: {
      wd_en: _vm.locale == 'en', wd_ch: _vm.locale == 'ch'
    },
    staticStyle: {
      "background-color": "#FFF",
      "border-radius": "20px",
      "border": "1px solid #F39800",
      "font-size": "16px",
      "color": "#F39800"
    },
    on: {
      "click": _vm.goInvoice
    }
  }, [_vm._v(_vm._s(_vm.$t("pay.addInvoice")))])]) : _vm._e(), _vm._v(" "), (_vm.register.regInvoiceType != null && _vm.register.regInvoiceType != '0') ? _c('span', {
    class: {
      mg_en: _vm.locale == 'en', mg_ch: _vm.locale == 'ch'
    }
  }, [_c('button', {
    class: {
      wd_en: _vm.locale == 'en', wd_ch: _vm.locale == 'ch'
    },
    staticStyle: {
      "background-color": "#FFF",
      "border-radius": "20px",
      "border": "1px solid #F39800",
      "font-size": "16px",
      "color": "#F39800"
    },
    on: {
      "click": _vm.goInvoice
    }
  }, [_vm._v(_vm._s(_vm.$t("pay.modInvoice")))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regConfig.cfgInvoiceFl == '1' && _vm.locale == 'ch'),
      expression: "regConfig.cfgInvoiceFl=='1'&&locale=='ch'"
    }],
    staticClass: "mline"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regConfig.cfgInvoiceFl == '1' && _vm.locale == 'ch' && _vm.register.regInvoiceType != null),
      expression: "regConfig.cfgInvoiceFl=='1' &&locale=='ch' && register.regInvoiceType!=null"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.register.regInvoiceType != '0'),
      expression: "register.regInvoiceType!='0'"
    }],
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      vtype_mg_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("morder.invoiceType")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvoiceType == '1' ? _vm.$t("invoice.invoiceType1") : _vm.$t("invoice.invoiceType2")))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.register.regInvoiceType == '1'),
      expression: "register.regInvoiceType=='1'"
    }],
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      vtype1_mg_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invRegTitle")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvTitle))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.register.regInvoiceType == '2'),
      expression: "register.regInvoiceType=='2'"
    }],
    class: {
      vad_mg_en: _vm.locale == 'en'
    }
  }, [_c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddOrg")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvOrg))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-6px",
      "margin-top": "10px"
    }
  }, [_c('label', {
    class: {
      o_label_en2: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddTax")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvTax))])]), _vm._v(" "), _c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddAddr")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvAddr))])]), _vm._v(" "), _c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddTel")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvTel))])]), _vm._v(" "), _c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddBank")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvBank))])]), _vm._v(" "), _c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddAcount")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvAccount))])])]), _vm._v(" "), (_vm.register.regInvoiceType != '0' && _vm.locale == 'ch') ? _c('div', [_c('div', {
    class: {
      ch_mg_contact: _vm.locale == 'ch', en_mg_contact2: _vm.locale == 'en'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("invoice.invGetName")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvoiceContact))])]), _vm._v(" "), _c('div', {
    class: {
      ch_mg_contact: _vm.locale == 'ch', en_mg_contact: _vm.locale == 'en'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("invoice.invGetPhone")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvoicePhone))])]), _vm._v(" "), _c('div', {
    class: {
      ch_mg_contact2: _vm.locale == 'ch', en_mg_contact: _vm.locale == 'en'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("invoice.invGetAddr")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvoiceAddr))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pay_offline_fl == '1' && _vm.regConfig.cfgBillUploadFl == '1'),
      expression: "pay_offline_fl=='1' && regConfig.cfgBillUploadFl=='1'"
    }]
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("order.voucher")))]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "file-box",
    staticStyle: {
      "text-align": "center",
      "display": "inline-block"
    }
  }, [_c('div', {
    staticClass: "preview",
    style: (_vm.bdPreview)
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        _vm.changeFile()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasImg),
      expression: "hasImg"
    }],
    staticStyle: {
      "text-align": "center",
      "margin-top": "-70px",
      "color": "#cfcfcf",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.uploadImg")))])])]), _vm._v(" "), (_vm.previewSrc != '') ? _c('div', {
    staticStyle: {
      "margin-left": "30px",
      "color": "red",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.uploadReImg")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pay_offline_fl == '1' && _vm.regConfig.cfgBillUploadFl == '1'),
      expression: "pay_offline_fl=='1' && regConfig.cfgBillUploadFl=='1'"
    }],
    staticStyle: {
      "font-size": "14px",
      "color": "#00AAEE",
      "margin-left": "30px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t("order.upVoucher")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.btnShow),
      expression: "btnShow"
    }],
    staticStyle: {
      "margin-top": "80px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t("pay.paySoon")))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": ""
    },
    on: {
      "on-ok": _vm.delHotel
    },
    model: {
      value: (_vm.modal1),
      callback: function($$v) {
        _vm.modal1 = $$v
      },
      expression: "modal1"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("info.orderInfo1")))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bbc9a0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/order.vue
// module id = 815
// module chunks = 10